import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

@Component({
  selector: 'app-floating-assistance-button',
  imports: [MatIconModule, CommonModule],
  templateUrl: './floating-assistance-button.component.html',
  styleUrl: './floating-assistance-button.component.scss',
})
export class FloatingAssistanceButtonComponent {
  expanded = true;
  textAsistencia = 'Asistencia';

  constructor( private router: Router) {}

  toggle() {
    this.expanded = !this.expanded;
  }

  goToAssistence() {
    this.router.navigate(['assistance']);
  }

  isAccountBanamex(): boolean {
    let allowedAccounts = ['2228', '2665', '2559', '2907', '2988', '2997', '2998', '2999'];
    const account = localStorage.getItem('account');
    return account ? allowedAccounts.includes(account) : false;
  }
}
